import { render, staticRenderFns } from "./ossManage.vue?vue&type=template&id=76c084f3&"
import script from "./ossManage.vue?vue&type=script&lang=js&"
export * from "./ossManage.vue?vue&type=script&lang=js&"
import style0 from "./ossManage.vue?vue&type=style&index=0&id=76c084f3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports